import type { PropsWithChildren, ReactNode } from 'react';

type PageProps = PropsWithChildren<{ title?: ReactNode; fullWidth?: boolean }>;

export const Page = ({ title, fullWidth = false, children }: PageProps) => (
  <section className={`mx-auto w-full ${fullWidth ? '' : 'max-w-5xl'}`}>
    {title && <h2 className="mb-6 text-2xl font-semibold text-gray-900">{title}</h2>}
    {children}
  </section>
);

export const Card = ({ children, className = '' }: PropsWithChildren<{ className?: string }>) => (
  <div className={`rounded-xl border border-gray-200 bg-white p-5 shadow-sm ${className}`}>
    {children}
  </div>
);

export const ErrorMessage = ({ children }: PropsWithChildren) => (
  <div role="alert" className="my-4 rounded-lg bg-red-50 p-4 text-sm text-red-700">
    {children}
  </div>
);

export const Loading = () => <div className="p-8 text-center text-gray-500">Загрузка...</div>;
